import React from 'react';

function CarePlanPage() {
  return (
    <div style={{ padding: '20px' }}>
      <h2>This is Care Plan Page</h2>
    </div>
  );
}

export default CarePlanPage;